import React, { useState, useEffect } from "react";
import { _InfinityFactoryContractGetDataByAddress } from "../../Services/Web3Connection";

function Status(props) {
  function Upcoming() {
    return (
      <>
        <div
          style={{
            padding: "4px",
            backgroundColor: "rgb(66 48 35)",
            borderRadius: "10px",
            display: "flex",
          }}
        >
          <span
            style={{
              color: "#d29813",
              marginRight: "4px",
              fontSize: "20px",
            }}
          >
            <svg
              stroke="currentColor"
              fill="currentColor"
              stroke-width="0"
              viewBox="0 0 16 16"
              height="1em"
              width="1em"
              xmlns="http://www.w3.org/2000/svg"
            >
              <circle cx="9" cy="9" r="4"></circle>
            </svg>
          </span>
          <span
            style={{
              color: "#dd6f20",
              fontWeight: "600",
              fontSize: "15px",
              marginRight: "5px",
            }}
          >
            Upcoming
          </span>
        </div>
      </>
    );
  }
  function Active() {
    return (
      <>
        <div
          className="ml-2"
          style={{
            padding: "4px",
            backgroundColor: "#1ed14b",
            borderRadius: "10px",
            display: "flex",
          }}
        >
          <span
            style={{
              color: "#059970",
              marginRight: "4px",
            }}
          >
            <svg
              stroke="currentColor"
              fill="currentColor"
              stroke-width="0"
              viewBox="0 0 16 16"
              height="1em"
              width="1em"
              xmlns="http://www.w3.org/2000/svg"
            >
              <circle cx="9" cy="9" r="4"></circle>
            </svg>
          </span>
          <span
            style={{
              color: "#005c12",
              fontWeight: "600",
              fontSize: "15px",
              marginRight: "5px",
            }}
          >
            Active
          </span>
        </div>
      </>
    );
  }
  function Ended() {
    return (
      <>
        <div
          style={{
            padding: "4px",
            backgroundColor: "#ff8085",
            borderRadius: "10px",
            display: "flex",
          }}
        >
          <span
            style={{
              color: "#ff0000",
              marginRight: "4px",
            }}
          >
            <svg
              stroke="currentColor"
              fill="currentColor"
              stroke-width="0"
              viewBox="0 0 16 16"
              height="1em"
              width="1em"
              xmlns="http://www.w3.org/2000/svg"
            >
              <circle cx="9" cy="9" r="4"></circle>
            </svg>
          </span>
          <span
            style={{
              color: "#8a2424",
              fontWeight: "600",
              fontSize: "15px",
              marginRight: "5px",
            }}
          >
            Ended
          </span>
        </div>
      </>
    );
  }

  // if (
  //   parseInt(new Date().getTime() / 1000) >= props.endDate / Math.pow(10, 18) ||
  //   props.hardCap <= props.raisedAmount
  // ) {
  //   return <Ended />;
  // }
  // if (
  //   // !(props.raisedAmount >= props.hardCap[1][2]) &&
  //   props.startDate / Math.pow(10, 18) >
  //   parseInt(new Date().getTime() / 1000 || props.raisedAmount === "")
  // ) {
  //   return <Upcoming />;
  // }

  // if (
  //   parseInt(new Date().getTime() / 1000) >= props.endDate / Math.pow(10, 18) ||
  //   props.hardCap <= props.raisedAmount
  // ) {
  //   return <Ended />;
  // }
  // if (
  //   !(
  //     parseInt(new Date().getTime() / 1000) >=
  //     props.endDate / Math.pow(10, 18)
  //   ) ||
  //   props.hardCap <= props.raisedAmount
  // ) {
  //   if (
  //     (props.startDate / Math.pow(10, 18) <=
  //       parseInt(new Date().getTime() / 1000) &&
  //       parseInt(new Date().getTime() / 1000) <
  //         props.endDate / Math.pow(10, 18)) ||
  //     props.hardCap > props.raisedAmount
  //   ) {
  //     return <Active />;
  //   }
  // }

  if (
    parseInt(new Date().getTime() / 1000) >= props.endDate / Math.pow(10, 18) ||
    props.hardCap / Math.pow(10, 18) <= props.raisedAmount / Math.pow(10, 18)
  ) {
    return <Ended />;
  }

  if (
    (props.startDate / Math.pow(10, 18) <=
      parseInt(new Date().getTime() / 1000) &&
      parseInt(new Date().getTime() / 1000) <
        props.endDate / Math.pow(10, 18)) ||
    props.hardCap / Math.pow(10, 18) < props.raisedAmount / Math.pow(10, 18)
  ) {
    return <Active />;
  }

  if (
    props.startDate / Math.pow(10, 18) >
    parseInt(new Date().getTime() / 1000 || props.raisedAmount === "")
  ) {
    return <Upcoming />;
  }
}

export default Status;
